module.exports = __webpack_public_path__ + "img/close.7b514f7a.svg";